jQuery(document).ready(function($) {

  if($(window).width() < 992) {
    $('.sfi--form__input--w').on('focus',function(){
      $('.sfi-calcul-sidebar').css('display','none');
    });

    $('.sfi--form__input--w').on('blur',function(){
      $('.sfi-calcul-sidebar').css('display','flex');
    });
  }


  $('.sfi-calc--form__validate').on('click',function(){
    // console.log('What what ?');
    setTimeout(function(){
      if(!$('.sfi-calc--result').hasClass('no-result') && !$('.sfi-calc--result').hasClass('error')){
        // console.log('no result');
        if($('.sfi-calc--form__validate').hasClass('sfi-calc-result')){
          // console.log('on remontre le form');
          $('.sfi-calc-form').css('max-height','9999px');
          $('.sfi-calc--form__validate').removeClass('sfi-calc-result');
          $('.sfi-calc--form__validate').html('Relancez le calcul');
        } else {
          // console.log('result cache form');
          $('.sfi-calc-form').css('max-height','0px');
          $('.sfi-calc-form').css('overflow','hidden');
          $('.sfi-calc--form__validate').addClass('sfi-calc-result');
          $('.sfi-calc--form__validate').html('Remonter');
        }
      }
    },0)
  });

//Bouton en mobile sur les pages single calculette pour afficher/masque le content
  $('.sfi-calcul-more').on('click',function(){
    if($(this).hasClass('more-open')){
      $(this).removeClass('more-open');
      $('.sfi-calcul-article').css('max-height','125px');
      $('.sfi-calcul-article:after').css('display','block');
      $('.sfi-calcul-article').addClass('is-cache');
    } else {
      $(this).addClass('more-open');
      $('.sfi-calcul-article').css('max-height','100%');
      $('.sfi-calcul-article').removeClass('is-cache');
    }
  });

  //Bouton en mobile sur les pages single calculette pour afficher les Calculettes
  //(Bouton qui est en fait la sidebar)
  $('.sfi-calcul-sidebar--outils_titre').on('click',function(){
    if($(this).hasClass('is-open')){
      $(this).removeClass('is-open');
      $('body').css('overflow','auto');
      $('.sfi-calcul-sidebar--outils-list').removeClass('is-open');
      $('.sfi-overlay').css('visibility','hidden');
      $('.sfi-overlay').css('opacity','0');
    } else {
      $(this).addClass('is-open');
      $('body').css('overflow','hidden');
      $('.sfi-calcul-sidebar--outils-list').addClass('is-open');
      $('.sfi-overlay').css('visibility','visible');
      $('.sfi-overlay').css('opacity','1');
    }
  });

  //Bouton en mobile qui permet de fermer la sidebar des calculettes (outils)
  $('.sfi-calcul-sidebar--outils-list_close').on('click',function(){
      $('.sfi-calcul-sidebar--outils_titre').removeClass('is-open');
      $('body').css('overflow','auto');
      $('.sfi-calcul-sidebar--outils-list').removeClass('is-open');
      $('.sfi-overlay').css('visibility','hidden');
      $('.sfi-overlay').css('opacity','0');
  });
});
